import { render } from "./Main.vue?vue&type=template&id=552a7763"
const script = {}
script.render = render

export default script